import { Link } from "react-router-dom";
import type { Movie } from "@/types";
import RatingStars from "@/components/base/RatingStars";

interface MovieCardProps {
  movie: Movie;
  index?: number;
}

export default function MovieCard({ movie, index = 0 }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block animate-fade-up overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-accent-300"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-primary-950">
        <img
          src={movie.poster}
          alt={`${movie.title}（${movie.year}）海报`}
          title={`${movie.title} 80年代经典电影海报`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 font-label text-xs font-semibold text-background-50">
          {movie.year}
        </span>
      </div>
      <div className="space-y-2 p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-accent-600">
          {movie.title}
        </h3>
        <p className="font-label text-xs text-foreground-600 line-clamp-1">
          {movie.originalTitle}
        </p>
        <div className="flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 3).map((genre) => (
            <span
              key={genre}
              className="rounded-md bg-secondary-100 px-2 py-0.5 font-label text-xs text-secondary-900"
            >
              {genre}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between pt-1">
          <RatingStars value={movie.rating} />
          <span className="font-label text-xs text-foreground-500">
            {movie.region}
          </span>
        </div>
      </div>
    </Link>
  );
}